<h3>{{ 'organizations' | translate }}</h3>

<app-ngb-table [config]="tableConfig" [sortingOrder]="{}" [data]="tableData$ | async"></app-ngb-table>
